import React, { RefObject, useRef, useState } from 'react';
import { Tabs } from 'antd';

import { useDidUpdate } from 'rooks';
import HistorySection from './HistorySection';
import CommentsSection from './CommentsSection';
import { ActivitiesSectionPageTypeEnum } from './enums';

import style from './ActivitiesDetailsSection.module.less';

type Props = {
  entityId: string;
  pageType: ActivitiesSectionPageTypeEnum;
  scrollRef: RefObject<HTMLElement>;
};

enum ActivitiesTabsEnum {
  Comments = 'comments',
  History = 'history',
}

const hiddenHistorySectionPages = [
  ActivitiesSectionPageTypeEnum.Worker,
  ActivitiesSectionPageTypeEnum.Company,
];

export default function ActivitiesDetailsSection(props: Props) {
  const { entityId, pageType, scrollRef } = props;

  const isVisibleCommentsSection =
    !hiddenHistorySectionPages.includes(pageType);

  const isVisibleHistorySection =
    pageType !== ActivitiesSectionPageTypeEnum.Company;

  const defaultTab = isVisibleCommentsSection
    ? ActivitiesTabsEnum.Comments
    : ActivitiesTabsEnum.History;

  const [activeTab, setActiveTab] = useState(defaultTab);
  const containerRef = useRef<HTMLDivElement>(null);

  useDidUpdate(() => {
    setActiveTab(defaultTab);
  }, [entityId]);

  return (
    <div ref={containerRef} className="page-inner-container">
      <Tabs
        className={style.activitiesTabs}
        activeKey={activeTab}
        destroyInactiveTabPane
        onChange={(activeTab: string) =>
          setActiveTab(activeTab as ActivitiesTabsEnum)
        }
      >
        {isVisibleCommentsSection && (
          <Tabs.TabPane key={ActivitiesTabsEnum.Comments} tab="Comments">
            <CommentsSection
              entityId={entityId}
              type={pageType}
              scrollRef={scrollRef}
              parentRef={containerRef}
            />
          </Tabs.TabPane>
        )}

        {isVisibleHistorySection && (
          <Tabs.TabPane key={ActivitiesTabsEnum.History} tab="History">
            <HistorySection
              entityId={entityId}
              pageType={pageType}
              scrollRef={scrollRef}
            />
          </Tabs.TabPane>
        )}
      </Tabs>
    </div>
  );
}
